export default __webpack_public_path__ + "images/63eeea7e6d18efc6c335e3ec584088d4-tankBullet1.png";